// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a60cebb","453":"6c28bf26","732":"cbe1c48c","977":"684346b6"}[chunkId] + ".chunk.js";
};